import { ReactElement } from 'react';
import SVGIcon, { ICONS } from './Icons';

interface IconProps {
  name: ICONS;
  color?: string;
  dataTestId?: string;
  width?: number;
  height?: number;
  tabIndex?: number;
  ariaLabel?: string | ICONS;
}

const Icon = ({
  name,
  color,
  dataTestId,
  width = 16,
  height = 16,
  tabIndex,
  ariaLabel = name,
}: IconProps): ReactElement => {
  return (
    <SVGIcon
      icon={name}
      style={{ color }}
      width={width}
      height={height}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      data-testid={dataTestId}
    />
  );
};

export default Icon;
